import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})

export class AuthJwtService {

  private pathAPI = environment.urlAPI;
  private authenticationChanged = new Subject<boolean>();
  
  constructor(private http: HttpClient) {    
  }

  public login(body: any): Observable<any> {
    let urlToken = this.pathAPI + 'Login';
    
    return this.http.post<any>(urlToken, body).pipe(
      tap(async (res: any) => {
        if (res.tokenMyPV.length > 0) {
          this.setStorageToken(res.tokenMyPV);
          this.setStorageRefreshToken(res.refreshTokenMyPV);
        }
      })
    );
  }

  public refreshToken(body: any): Observable<any> {

    let urlToken = this.pathAPI + 'Login/Refresh';
    return this.http.post<any>(urlToken, body).pipe(
      tap(async (res: any) => {
        if (res.tokenMyPV.length > 0) {
          this.setStorageToken(res.tokenMyPV);
          this.setStorageRefreshToken(res.refreshTokenMyPV);          
        }
      })
    );
  }

  public logout(): void {
    this.setStorageToken(undefined);
  }

  public setToken(data: any): void {
    this.setStorageToken(data.tokenMyPV);
    this.setStorageRefreshToken(data.refreshTokenMyPV);
  }

  private setStorageToken(value: any): void {
    window.localStorage['tokenMyPV'] = value;
    this.authenticationChanged.next(this.isAuthenticated());
  }

  private setStorageRefreshToken(value: any): void {
    window.localStorage['refreshTokenMyPV'] = value;
  }

  public isAuthenticated(): boolean {
    return (!(window.localStorage['tokenMyPV'] === undefined ||
      window.localStorage['tokenMyPV'] === null ||
      window.localStorage['tokenMyPV'] === 'null' ||
      window.localStorage['tokenMyPV'] === 'undefined' ||
      window.localStorage['tokenMyPV'] === ''));
  }

  public isAuthenticationChanged(): any {
    return this.authenticationChanged.asObservable();
  }

  public getToken(): any {
    if (window.localStorage['tokenMyPV'] === undefined ||
      window.localStorage['tokenMyPV'] === null ||
      window.localStorage['tokenMyPV'] === 'null' ||
      window.localStorage['tokenMyPV'] === 'undefined' ||
      window.localStorage['tokenMyPV'] === '') {
      return '';
    }
    let obj = window.localStorage['tokenMyPV'];
    return obj;
  }

  public getRefreshToken(): any {
    if (window.localStorage['refreshTokenMyPV'] === undefined ||
      window.localStorage['refreshTokenMyPV'] === null ||
      window.localStorage['refreshTokenMyPV'] === 'null' ||
      window.localStorage['refreshTokenMyPV'] === 'undefined' ||
      window.localStorage['refreshTokenMyPV'] === '') {
      return '';
    }
    let obj = window.localStorage['refreshTokenMyPV'];
    return obj;
  }

}
